import React from 'react'
import { useDispatch } from 'react-redux'
import './Popup.scss'
import { closeCurrentPopup } from '../../Store/InterfaceSlice'

interface PopupProps {
  preventClose?: true
  children?: JSX.Element[] | JSX.Element
  fullscreen?: true
  className?: string
  title?: string
}

export function Popup(props: PopupProps) {
  const dispatch = useDispatch()

  return (
    <div
      className={`popup-container ${props.fullscreen ? 'fullscreen' : ''} ${
        props.className
      }`}
      onClick={() => dispatch(closeCurrentPopup())}
    >
      <div
        className="popup-pane"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {!props.preventClose && (
          <div
            className="popup-close button button-secondary"
            onClick={() => dispatch(closeCurrentPopup())}
          >
            ❌
          </div>
        )}
        {props.title != null && props.title !== '' ? (
          <div className="popup-title">{props.title}</div>
        ) : null}
        <div className="popup-content">{props.children}</div>
      </div>
    </div>
  )
}
